export default __webpack_public_path__ + "static/media/0025.db8d0499.WAV";